// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ucxr","left":"styles_left__215DF","desktopActions":"styles_desktopActions__7kO3B","title":"styles_title__3ngmq"};